import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import "@hotwired/turbo-rails";
import "~/javascript/controllers";
